import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'userManagement',
  initialState: {
    userProfileInfo: JSON.parse(localStorage.getItem('user-profile') || '{}') as any,
    email: '',
    userRole: JSON.parse(localStorage.getItem('user-role') || '{}') as any
  },
  reducers: {
    setUserProfileInfo: (state, action) => {
      state.userProfileInfo = action.payload;
      localStorage.setItem('user-profile', JSON.stringify(action.payload));
    },
    registerEmail: (state, action) => {
      state.email = action.payload;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
      localStorage.setItem('user-role', JSON.stringify(action.payload));
    }
  }
});

export const { setUserProfileInfo, registerEmail, setUserRole } = userSlice.actions;

export default userSlice.reducer;
